import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import ArticleList from "/react4xp/components/shared/ArticleList/ArticleList";
import Pagination from "/react4xp/components/shared/Pagination/Pagination";
import type { NewsPartProps } from "./News.d";

export const NewsPart = (props: ComponentProps<PartData>) => {
  const {
    linkDiakonhjemmetHageType,
    title,
    linkDiakonhjemmetHageShow,
    linkDiakonhjemmetHageUrl,
    linkDiakonhjemmetHageTitle,
    newsList,
    linkReadMore,
    pagination,
    showIngress,
    currentPage,
    totalPage,
    limitPage,
    urlPage,
  } = (props.data as NewsPartProps) ?? {};

  let targetlinkDiakonhjemmetHage = "";
  if (linkDiakonhjemmetHageType == "external") {
    targetlinkDiakonhjemmetHage = "_blank";
  }

  return (
    <section className="container">
      {title && <h2 className="frontpage-section-title">{title}</h2>}

      {linkDiakonhjemmetHageShow && (
        <a
          className="garden-cta-btn"
          href={linkDiakonhjemmetHageUrl}
          target={targetlinkDiakonhjemmetHage}
        >
          {linkDiakonhjemmetHageTitle}
        </a>
      )}

      <ArticleList items={newsList} columns={limitPage === 4 ? 4 : 3} showIngress={showIngress} />

      {linkReadMore && (
        <div className="read-more-link">
          <a href={linkReadMore}>Se alle saker</a>
        </div>
      )}

      {pagination && (
        <Pagination
          current={currentPage}
          pages={totalPage}
          limit={limitPage}
          pageurl={urlPage}
        />
      )}
    </section>
  );
};

export default NewsPart;
